var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 2.16666C7.81699 2.16666 6.04199 3.94166 6.04199 6.12499C6.04199 8.26666 7.71699 9.99999 9.90033 10.075C9.96699 10.0667 10.0337 10.0667 10.0837 10.075C10.1003 10.075 10.1087 10.075 10.1253 10.075C10.1337 10.075 10.1337 10.075 10.142 10.075C12.2753 9.99999 13.9503 8.26666 13.9587 6.12499C13.9587 3.94166 12.1837 2.16666 10.0003 2.16666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2338 12.3C11.9088 10.75 8.11712 10.75 5.77546 12.3C4.71712 13 4.13379 13.9583 4.13379 14.9833C4.13379 16.0083 4.71712 16.9583 5.76712 17.6583C6.93379 18.4417 8.46712 18.8333 10.0005 18.8333C11.5338 18.8333 13.0671 18.4417 14.2338 17.6583C15.2838 16.95 15.8671 16 15.8671 14.9667C15.8588 13.95 15.2838 12.9917 14.2338 12.3ZM11.9421 14.3L9.84212 16.4C9.74212 16.5 9.60879 16.55 9.47546 16.55C9.34212 16.55 9.20879 16.4917 9.10879 16.4L8.05879 15.35C7.85879 15.15 7.85879 14.8167 8.05879 14.6167C8.25879 14.4167 8.59212 14.4167 8.79212 14.6167L9.47546 15.3L11.2088 13.5667C11.4088 13.3667 11.7421 13.3667 11.9421 13.5667C12.1505 13.7667 12.1505 14.1 11.9421 14.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTick);
export default __webpack_public_path__ + "static/media/profile-tick.e6c98db67936484a09fe5339291dd4c2.svg";
export { ForwardRef as ReactComponent };